import { useRef } from 'react';

export const useConstructor = <T extends Function>(callback: T) => {
  const isCalled = useRef(false);

  if (!isCalled.current) {
    callback();
    isCalled.current = true;
  }
};
